import { render, staticRenderFns } from "./AnxForm.vue?vue&type=template&id=7db652f3&scoped=true&"
import script from "./AnxForm.vue?vue&type=script&lang=ts&"
export * from "./AnxForm.vue?vue&type=script&lang=ts&"
import style0 from "./AnxForm.vue?vue&type=style&index=0&id=7db652f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db652f3",
  null
  
)

export default component.exports